import {
  getNumber,
  getString,
  getArray,
} from "../../../../../utils/mappersUtils/object";

/**
 * For a single item object, produce exactly 1 "item row"
 *
 * If item has shortDescription => "group" with 2 keys: ["description","shortDescription"]
 * If no shortDescription => single field with key "description"
 * Also sets a `groupKeys` array so the table can detect
 * how many fields are in the group if it needs to create them.
 */
export function checklistItemMapper(itemObj) {
  const itemId = getNumber(itemObj, "id", 0);
  const baseDesc = getString(itemObj, "description", "");
  const baseShort = getString(itemObj, "shortDescription", "");

  let groupKeys = [];
  if (baseShort) {
    groupKeys = ["description", "shortDescription"];
  } else {
    groupKeys = ["description"];
  }

  const itemDetails = getArray(itemObj, "itemDetails");

  const translations = {};
  itemDetails.forEach((det) => {
    const lang = getString(det, "language", "");
    if (!lang) return;

    // For each language, we'll build a "group" array of {key, value}
    const groupArray = groupKeys.map((key) => {
      return {
        key,
        value: getString(det, key, ""),
        maxLength: key === "description" ? 256 : key === "shortDescription" ? 40 : undefined,
      };
    });

    translations[lang] = { group: groupArray };
  });

  return [
    {
      id: itemId,
      type: "ITEM",
      baseTranslations: {
        description: baseDesc,
        shortDescription: baseShort,
      },
      groupKeys,
      translations,
      fieldLimits: {
        description: 256,
        shortDescription: 40
      }
    },
  ];
}
